<app-navbar></app-navbar>

<!-- Page Banner -->
<div class="rs-page-banner">
  <div class="rs-pb-deco">
    <div class="rs-pb-dots"></div>
    <div class="rs-pb-circle rs-pb-c1"></div>
    <div class="rs-pb-circle rs-pb-c2"></div>
  </div>
  <div class="container">
    <div class="rs-pb-content">
      <h1 class="rs-pb-title">Video Gallery</h1>
      <nav class="rs-pb-breadcrumb">
        <a routerLink="/">Home</a>
        <i class="ri-arrow-right-s-line"></i>
        <span>Video Gallery</span>
      </nav>
    </div>
  </div>
</div>

<!-- Content -->
<div class="rs-inner-page">
  <div class="container">

    <!-- Loading -->
    <div *ngIf="fetchinData" class="rs-inner-skeleton"></div>

    <ng-container *ngIf="!fetchinData && mainResponse.length != 0">

      <!-- Breadcrumb nav -->
      <div class="rs-breadcrumb-nav" *ngIf="folders.length">
        <i class="ri-home-4-line" style="color:#d3363a;"></i>
        <a [routerLink]="['/gallery/videos']">Video Gallery</a>
        <ng-container *ngFor="let path of folders; let last = last; trackBy: trackByFn2">
          <span class="rs-bc-sep"><i class="ri-arrow-right-s-line"></i></span>
          <ng-container *ngIf="!last">
            <a style="cursor:pointer;color:#d3363a;font-weight:600;" (click)="Goto(path.id)">{{ path.name }}</a>
          </ng-container>
          <ng-container *ngIf="last">
            <span class="rs-bc-current">{{ path.name }}</span>
          </ng-container>
        </ng-container>
      </div>

      <!-- Sub-folders -->
      <div *ngIf="album.length != 0">
        <div class="rs-inner-section-title">
          <div class="rs-ist-sub"><i class="ri-folder-video-line"></i> Albums</div>
          <h2>Video Albums</h2>
        </div>
        <div class="row g-3 mb-5">
          <div class="col-xl-4 col-lg-4 col-md-6 wow fadeIn"
               *ngFor="let albumItem of album; let i = index"
               [attr.data-wow-delay]="(i * 0.08 + 0.1) + 's'">
            <div class="rs-album-card" [routerLink]="['/videoFolder', albumItem.Id]">
              <div class="rs-album-thumb">
                <img *ngIf="albumItem.ThumbnailLink"
                     [src]="TransformUrl(albumItem.ThumbnailLink)" alt="Video album"
                     (load)="onImageLoad()">
                <div class="rs-album-thumb-icon" *ngIf="!albumItem.ThumbnailLink">
                  <i class="ri-video-line"></i>
                </div>
                <div class="rs-gallery-play-icon" *ngIf="albumItem.ThumbnailLink">
                  <i class="ri-play-circle-fill"></i>
                </div>
              </div>
              <div class="rs-album-body">
                <h5>{{ albumItem.AlbumName }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Videos -->
      <div *ngIf="files.length != 0">
        <div class="rs-inner-section-title">
          <div class="rs-ist-sub"><i class="ri-play-circle-line"></i> Videos</div>
          <h2>All Videos</h2>
        </div>
        <div class="rs-video-grid">
          <div class="rs-video-frame wow fadeIn"
               *ngFor="let item of files; let i = index"
               [attr.data-wow-delay]="(i * 0.08) + 's'">
            <iframe [src]="convertToEmbedUrl(item.VideoId) | safe"
                    width="100%" height="220"
                    frameborder="0" allowfullscreen
                    webkitallowfullscreen mozallowfullscreen>
            </iframe>
          </div>
        </div>
      </div>

    </ng-container>

    <!-- No data -->
    <div *ngIf="!fetchinData && mainResponse.length == 0" class="rs-empty-state">
      <i class="ri-video-off-line"></i>
      <h4>No video data found</h4>
    </div>

  </div>
</div>
